export type PlayerControlsStyleType = typeof PlayerControlsStyles;

export const PlayerControlsStyles = {
  largeScreenBreakpoint: 1440,
  closeButtonTop: 44,
  closeButtonRight: 32.5,
};
